const TituloTab = (props) => {
    const {
        titulo,
        icon
    } = props

    return <h6 className="mb-0">{icon ? <div style={{ display: "inline" }}>{icon} </div> : false }{titulo}</h6>
}

export default TituloTab